module.exports = __webpack_public_path__ + "img/t1-8.6cbd3dc7.png";